import { useLegalStore } from '@/features/legal/store/legal.store';
import { useApplicationStore } from '@/features/application/store/application.store';
import { useNavigationStore } from '@/features/application/store/navigation.store';
import { useLogoStore } from '@/features/application/store/logo.store';
import { useUIStore } from '@/features/dashboard/stores/ui.store';
import { useSubscriptionStore } from '@/features/auth/stores/subscription.store';
import { useDashboardStore } from '@/features/dashboard/stores/dashboard.store';
import { logger } from '@/features/help/utils/logger';

/**
 * Resets the state of all Zustand stores to their initial values.
 * This is typically called on user logout.
 */
export const resetAllStores = () => {
  logger.info('store-resets', 'Resetting all application stores...');

  useLegalStore.getState().resetLegalState();

  useApplicationStore.setState({
    structure: null,
    recordId: null,
    hasMappings: false,

    files: {},
  });

  useNavigationStore.setState({
    activePage: 0,
  });

  useLogoStore.getState().clearLogo();

  useUIStore.setState({ isMenuOpen: false });

  useSubscriptionStore.setState({
    isSubscribed: false,
    prices: null,
    standardUsageCount: 0,
    premiumUsageCount: 0,
    freeUsageCount: 0,
    totalUsageCount: 0,
    standardApplicationPrice: null,
    premiumApplicationPrice: null,
    currentPeriodEnd: null,
    status: null,
    isModalOpen: false,
  });

  useDashboardStore.getState().resetDashboardState();

  logger.info('store-resets', 'All stores have been reset.');
};
